import { ref, onMounted, computed } from 'vue';
import { useCalendlyWidget } from '../../compositions/component-lib.esm25.js';
import { useMounted } from '../../compositions/component-lib.esm4.js';

//
var script = {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const isMounted = useMounted();
    const root = ref(null);
    const isLoaded = ref(false);
    function load() {
      if (!isMounted.value) return;
      isLoaded.value = true;
      Calendly.initInlineWidget({
        url: props.id,
        parentElement: root.value
      });
    }
    useCalendlyWidget(load);
    onMounted(() => {
      if (window && window.Calendly) load();
    });
    const classes = computed(() => ({
      'v-calendly--loaded': isLoaded.value
    }));
    return {
      root,
      classes
    };
  }
};
export { script as default };